import React from 'react';
import Table from 'react-bootstrap/Table';
import GetDataApi from '../../../../Components/Common/FetchData/GetDataApi';
import { IOnlineVisitor } from './type/onlineVisitorType';
import CommAccordian from '../../../../Components/Common/CommAccordian';
import { Link } from 'react-router-dom';
import ExcelGenerator from '../../../Common/excel/ExcelGenerator';

const OnlineVisitors = () => {
  const { getData, loading, response } = GetDataApi<IOnlineVisitor[]>(
    '/api/fair/exhibitor/lead/online-visitor-leads'
  );
  return (
    <>
      <div className='profile-right-side px-3 py-3'>
        <div className='d-flex  align-items-center justify-content-between'>
          <h5>Online Leads</h5>

          <div className='d-flex align-items-center gap-2'>
            <ExcelGenerator
              excelName={`Leads`}
              excelTableHead={[
                'Visitor Name',
                'Phone',
                'Email',
                'Product Name',
                'Comment',
              ]}
              excelData={
                response?.length
                  ? response?.map((sData) => {
                      const data = {
                        'Visitor Name': sData?.visitor_name,
                        Phone: sData.visitor_phone,
                        Email: sData.visitor_email,
                        'Product Name': sData.product_name,
                        Comment: sData.comment,
                      };
                      return data;
                    })
                  : []
              }
            />
          </div>
        </div>
        <div className='profile-right-info pt-3 ps-2'>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>SL.</th>
                <th>Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Product Name</th>
                <th>Comment</th>
              </tr>
            </thead>
            <tbody>
              {response && response?.length ? (
                response?.map((visitor, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{visitor.visitor_name}</td>
                    <td>{visitor.visitor_phone}</td>
                    <td>{visitor.visitor_email}</td>
                    <td>
                      <Link
                        to={`/product-services/exhibitor/details/${visitor.exhibitor_id}`}
                        className='text-decoration-none'
                      >
                        {visitor.product_name}
                      </Link>
                    </td>
                    <td>
                      <CommAccordian text={visitor.comment || 'N/A'} />
                    </td>
                  </tr>
                ))
              ) : (
                <tr className='text-center'>
                  <td colSpan={5} className='fw-bold'>
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </>
  );
};

export default OnlineVisitors;
